module.exports = __webpack_public_path__ + "img/img_sec2_01.192e5f42.png";